import React from "react";

interface IconIProps {
  size?: string;
}

const PersonIcon = ({ size = "12" }: IconIProps) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 11.75V10.5278C10.75 9.17775 9.63071 8.08333 8.25 8.08333H3.25C1.86929 8.08333 0.75 9.17775 0.75 10.5278V11.75M8.25 3.19444C8.25 4.54447 7.13071 5.63889 5.75 5.63889C4.36929 5.63889 3.25 4.54447 3.25 3.19444C3.25 1.84441 4.36929 0.75 5.75 0.75C7.13071 0.75 8.25 1.84441 8.25 3.19444Z"
        stroke="#848E98"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default PersonIcon;
